import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { readSchools } from "../../../store/actions/schoolActions";
import { fetchLogo } from "../../../store/actions/logoActions";
import backgroundImage from "./1a5b.png";

const ProvisionalCertificate = () => {
  const dispatch = useDispatch();
  const { schools } = useSelector((state) => state.schoolDetails);
  const { logoUrl } = useSelector((state) => state.logo);

  useEffect(() => {
    dispatch(readSchools());
    dispatch(fetchLogo());
  }, [dispatch]);

  const Logo = logoUrl;

  const styles = {
    container: {
      fontFamily: "Arial, sans-serif",
      width: "210mm", // A5 width
      height: "148mm", // A5 height
      margin: "0 auto",
      padding: "10mm", // Ensure space for the border
      position: "relative",
      backgroundImage: `url(${backgroundImage})`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      backgroundPosition: "center",
      boxSizing: "border-box",
    },
    watermark: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      zIndex: 0,
      opacity: 0.1, // Subtle watermark
      width: "150px", // Adjusted for A5 size
      height: "150px",
      backgroundImage: `url(${Logo})`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "contain",
      backgroundPosition: "center",
    },
    content: {
      position: "relative",
      zIndex: 1, // Ensure content is above watermark
    },
    header: {
      textAlign: "center",
      marginBottom: "5px",
    },
    logo: {
      marginTop:"-20px",
      width: "60px",
      height: "60px",
    },
    title: {
      fontSize: "20px",
      fontWeight: "bold",
      margin: "5px 0",
    },
    subText: {
      fontSize: "12px",
      color: "#555",
    },
    section: {
      marginBottom: "10px",
      // lineHeight: "1.5",
    },
    footer: {
      textAlign: "right",
      marginBottom: "20px",
      marginRight:"20px",
    },
  };

  return (
    <div style={styles.container}>
      {/* Watermark */}
      <div style={styles.watermark}></div>

      {/* Content */}
      <div style={styles.content}>
        <div style={styles.header}>
          <img src={Logo} alt="School Logo" style={styles.logo} />
          {schools.length > 0 ? (
            schools.map((school, index) => (
              <div key={index}>
                <h2 style={styles.title}> {school.school_name} </h2>
                <p style={{ fontWeight: "bold", color: "#000" }}>
                  {school.city}, {school.district}, {school.state},{" "}
                  {school.postal_code}
                  <br />
                </p>
                <p style={styles.subText}>
                  (Affiliated to MBOSE | School Code: 280)
                </p>
              </div>
            ))
          ) : (
            <>
              <h2>Name of School</h2>
              <p style={{ fontWeight: "bold", color: "#000" }}>
                City, District, State - Pin code
                <br />
              </p>
            </>
          )}
        </div>

        <div style={styles.section}>
          <h2 style={{ textAlign: "center" }}>Provisional Certificate</h2>
          <p>
            <strong>Certificate No:</strong> [Certificate Number] <br />
            <strong>Date:</strong> [Issue Date]
          </p>
        </div>

        <div style={styles.section}>
          <p>
            This is to certify that <strong>[Student's Full Name]</strong>,
            son/daughter of <strong>[Father's Name]</strong> and{" "}
            <strong>[Mother's Name]</strong>, a student of this institution, has
            successfully completed the requirements for the{" "}
            <strong>Secondary School Leaving Certificate (SSLC)</strong>{" "}
            Examination conducted by the{" "}
            <strong>Meghalaya Board of School Education (MBOSE)</strong> in the
            academic session <strong>[Year]</strong>.
          </p>
        </div>

        <div style={styles.section}>
          <p style={{ lineHeight: "1.2" }}>
            The candidate’s <strong>Roll Number</strong> is{" "}
            <strong>[Roll No]</strong>, and he/she has been awarded the result
            as <strong>[Pass/Division]</strong>.
          </p>
          <p style={{ lineHeight: "1.2" }}>
            This provisional certificate is issued at the request of the
            student for official purposes until the final certificate is issued
            by MBOSE.
          </p>
        </div>

        <div style={styles.footer}>
          <p>
            <strong>Principal's Signature</strong> <br />
            [Principal's Name] <br />
            <strong>Seal of the School</strong>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProvisionalCertificate;
